import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=c2904d5e&scoped=true&lang=html"
import script from "./refresh.vue?vue&type=script&lang=js"
export * from "./refresh.vue?vue&type=script&lang=js"
import style0 from "./refresh.vue?vue&type=style&index=0&id=c2904d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2904d5e",
  null
  
)

export default component.exports